<script setup lang="ts">
import { ref } from 'vue'
import { FilterField, TableField } from "../../../../components/table/table";
import { Permission } from '../../../../types/auth'
import ListTemplate from "../../../../components/ui/common/ListTemplate.vue";
import ChartOfAccountsForm from './ChartOfAccountsForm.vue';
import { tokenManager } from '../../../../api/utils/tokenManager';

withDefaults(defineProps<{
  showHeader?: boolean,
  showQuickTour?: boolean,
  showTitle?: boolean,
  showNextButton?: boolean
}>(), {
  showHeader: true,
  showQuickTour: true,
  showTitle: true
})

const endPoint = '/clients/finance/accounting/chart-of-accounts/'
const title = 'Chart of Accounts'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const fields: TableField[] = [
  { name: 'code', caption: 'Code', sortable: true, fieldType: 'text' },
  { name: 'name', caption: 'Name', sortable: true, fieldType: 'text' },
  { name: 'currency_name', caption: 'Currency', sortable: true, fieldType: 'text' },
  { name: 'amount', caption: 'Amount', sortable: true, fieldType: 'number' },
  { name: 'allow_reconciliation', caption: 'Allow Reconciliation', sortable: true, fieldType: 'boolean' },
  { name: 'allow_depreciation', caption: 'Allow Depreciation', sortable: true, fieldType: 'boolean' },
  { name: 'active', caption: 'active', sortable: false, fieldType: 'status' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
     options: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleAction = (action: string, item: any) => {
  if (action === 'reconcile') {
    tokenManager.setData(item)
    window.location.href = 'finance/accounting/reconciliation'
  }
}
const permissions = ref<Permission[]>()
const handleData = (data : any) => {
  selectedData.value = data
}
</script>

<template>
  <ListTemplate :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[
    { name: 'reconcile', variant: 'primary', title: 'Reconcile', icon: 'FolderSync', permission: 'reconcile', visible: (item) => item.allow_reconciliation },
  ]" :filterFields ="filterFields"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" @custom="handleAction"
  @data="handleData" :show-header="showHeader" :show-quick-tour="showQuickTour" :show-title="showTitle" @permissions="permissions = $event">
  <template #form-view>
    <ChartOfAccountsForm
      :permissions="permissions"
      v-if="showForm"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
</template>